<template>
  <!-- 编辑解析器 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >

      <v-form ref="form" :model="ruleForm" :rules="rules">
        <v-form-item  prop="analysis_name" >
          <template slot="label">
            <span class="required">*</span>
            <span>解析器名称</span>
          </template>
          <v-input type="text" name="analysis_name" v-model="ruleForm.analysis_name"></v-input>
        </v-form-item>
        <v-form-item  prop="analysis_desc" >
          <template slot="label">
            <span class="required">*</span>
            <span>描述</span>
          </template>
          <v-input type="textarea" class="remarks" name="analysis_desc" :maxlength="200" v-model="ruleForm.analysis_desc" show-word-limit></v-input>
        </v-form-item>

      </v-form>
    </v-dialog>

  </div>

</template>

<script>
import { copy } from '@/common/libs/utils';

export default {
  components: {},
  props:{
  showInputDialog:{
    type:Boolean,
    default: false
  },
  infoData:{
    type:Object,
    default: ()=>{}
  }

},
  data() {
    return {
      rules: {
        analysis_name: copy([{
          type: "nameInput"
        }]),
      },
      ruleForm:{
        analysis_name: "",
        analysis_desc: "",
        open_status: 1,
        app_id: sessionStorage.getItem("appid") || "",
      },

      dialogTitle: "编辑解析器",

      isShow:false,
    };
  },
  created() {
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    open(){
      this.ruleForm = copy(this.infoData)
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      let submitData = { ...this.ruleForm };
      this.$put("/td/td-iot-api/iot/rule/analysis/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
